<template>
  <span>
    Payment Reminder sent to
    <router-link
      tag="a"
      :to="`/customers/view/${eventLog.customerId}`"
      >{{ eventLog.customerName }}</router-link
    >&nbsp; for invoice
    <router-link tag="a" :to="`/invoices/view/${eventLog.invoiceId}`"
      >#{{ eventLog.invoiceNumber }}</router-link
    >
  </span>
</template>
<script>
export default {
  name: 'recentActivityTableDescriptionReminderSent',
  props: {
    eventLog: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
